var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF004F",
    d: "M20.34 13.22A8.1 8.1 0 0 0 25 14.686V11.4a4.8 4.8 0 0 1-.98-.1v2.586a8.1 8.1 0 0 1-4.66-1.465v6.706c0 3.355-2.767 6.074-6.18 6.074a6.23 6.23 0 0 1-3.44-1.027 6.22 6.22 0 0 0 4.418 1.827c3.414 0 6.181-2.72 6.181-6.074zm1.206-3.315a4.54 4.54 0 0 1-1.207-2.681v-.423h-.927a4.6 4.6 0 0 0 2.134 3.104M11.9 21.6a2.74 2.74 0 0 1-.577-1.682c0-1.534 1.266-2.778 2.828-2.778.29 0 .58.044.857.13v-3.36a6 6 0 0 0-.978-.055v2.615a2.9 2.9 0 0 0-.858-.13c-1.562 0-2.827 1.244-2.827 2.778 0 1.085.632 2.025 1.555 2.482"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.362 12.42a8.1 8.1 0 0 0 4.66 1.466V11.3a4.7 4.7 0 0 1-2.475-1.394 4.6 4.6 0 0 1-2.134-3.104h-2.436v13.126c-.006 1.53-1.27 2.769-2.828 2.769a2.84 2.84 0 0 1-2.25-1.097 2.77 2.77 0 0 1-1.555-2.482c0-1.534 1.265-2.778 2.827-2.778.3 0 .587.046.857.13v-2.615c-3.354.068-6.05 2.761-6.05 6.073a6 6 0 0 0 1.762 4.247 6.23 6.23 0 0 0 3.44 1.027c3.413 0 6.182-2.72 6.182-6.074z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00F2EA",
    d: "M24.021 11.3v-.7a4.7 4.7 0 0 1-2.474-.695 4.7 4.7 0 0 0 2.474 1.394M19.413 6.8a5 5 0 0 1-.052-.377V6h-3.363v13.126c-.005 1.53-1.269 2.769-2.827 2.769-.458 0-.89-.107-1.272-.297a2.84 2.84 0 0 0 2.25 1.097c1.558 0 2.822-1.24 2.828-2.77V6.802zm-5.384 7.053v-.745a6 6 0 0 0-.848-.056C9.767 13.052 7 15.772 7 19.126c0 2.103 1.088 3.956 2.74 5.047a6 6 0 0 1-1.761-4.247c0-3.312 2.697-6.005 6.05-6.073"
  })));
};
export default SvgTiktok;